import React from 'react';
import "./Fancy.css";

const Fancy = () => {
  return (
    <div id="containerFancy">
      <p id ="fancyId">"We are a group of professionals who share a passion for technology. We are risk takers, not excuse makers."
      </p>
    </div>
  )
}

export default Fancy;



// WEBPACK FOOTER //
// ./src/components/About/Fancy/Fancy.js